var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZealyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_255_6528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 0H0V22H22V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_255_6528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.40824 2.42042L0.579051 2.37649L0.575296 3.21391L0.574873 3.38851C0.574629 3.52444 0.574301 3.75921 0.573972 4.15468C0.573306 4.94564 0.572648 6.37998 0.572648 8.95392V9.28453L1.55513 10.2754C1.16611 10.5223 0.775259 10.7663 0.382607 11.0074L0.00307866 11.2405L0 16.7608L4.5317 21.3341L4.82927 21.3537C10.3898 21.72 16.1086 21.3136 21.4666 19.4493L22 19.2637V12.6304L20.8408 11.4613C21.0383 11.2646 21.2353 11.0664 21.431 10.8668L21.6596 10.6335V10.3056C21.6596 10.0791 21.6603 8.89356 21.6609 7.76401L21.6624 5.23119L16.9948 0.523682L16.5302 0.680652C11.7061 2.3105 6.53218 2.69171 1.40824 2.42042ZM16.7816 1.43751L20.8708 5.56162C20.8708 5.56162 20.8682 9.85216 20.8682 10.3056C20.6738 10.5038 20.4778 10.7011 20.2811 10.8968C20.0928 11.0843 19.9039 11.2705 19.7151 11.4548L21.2085 12.961V18.6947C15.9793 20.5142 10.3727 20.919 4.88081 20.5572L0.79164 16.4304L0.794277 11.6891C1.24145 11.4145 1.68637 11.1362 2.12899 10.8541C2.35737 10.7085 2.5851 10.562 2.81227 10.4144L1.3641 8.95392C1.3641 6.2219 1.36485 4.77404 1.36555 4.01679C1.36617 3.34721 1.36675 3.21748 1.36675 3.21748C1.6303 3.23147 1.89412 3.24376 2.15809 3.25418C7.08846 3.4499 12.0848 3.02439 16.7816 1.43751Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2853 7.64793V9.94672C16.7342 12.3998 14.1831 14.5391 11.6346 16.4468C14.2991 16.2685 16.9611 15.8401 19.6282 15.0632C19.6282 15.912 19.6282 16.7581 19.6282 17.6069C15.9506 18.6818 12.2756 19.0889 8.60066 19.0889C7.88837 19.0889 7.17608 19.0728 6.46369 19.0436V16.7447C9.01482 15.1085 11.5659 13.3018 14.1144 11.2345C12.281 11.4713 10.4474 11.5724 8.6138 11.5724C8.08615 11.5724 7.56123 11.5644 7.03358 11.5484C7.03358 10.6997 7.03358 9.8536 7.03358 9.00483C7.55588 9.02078 8.07564 9.02876 8.59803 9.02876C12.1596 9.02876 15.7211 8.6483 19.2827 7.6452L19.2853 7.64793Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZealyIcon);
export default __webpack_public_path__ + "static/media/ZealyIcon.7ea9ee0f2e62a553b844d19b871a4765.svg";
export { ForwardRef as ReactComponent };